/** Practice frontend URL (prod vs dev), aligned with `public/js/practice-link.js`. */
export function getPracticeSiteUrl(): string {
  const fromEnv = import.meta.env.VITE_PRACTICE_SITE_URL as string | undefined;
  if (fromEnv) {
    return fromEnv;
  }
  const host = window.location.hostname;
  const isDev =
    host === 'localhost' || host === '127.0.0.1' || host.indexOf('dev.') === 0;
  return isDev
    ? 'https://dev-thuchanh.gioitienganh.vn'
    : 'https://thuchanh.gioitienganh.vn';
}
